// extracted by mini-css-extract-plugin
module.exports = {"root":"OldPrice_root__A8g9Z","crossed":"OldPrice_crossed__0ZmGu"};